import { Link } from "@tanstack/react-router";
import { Trans } from "react-i18next";

import { useUser } from "~/hooks/use-user";

function SubscriptionDue() {
  return (
    <p className="text-red-500 text-sm font-semibold">
      <Trans
        key="trial_ended"
        i18nKey="subscription_due_banner"
        components={{
          upgradeLink: (
            <Link
              to="/settings/account/contracts"
              className="font-bold underline"
            />
          ),
        }}
      />
    </p>
  );
}

export default function SubscriptionDueBanner() {
  const { user } = useUser();
  const periodEndDate = user.subscription?.periodEnd;

  if (!periodEndDate || user.subscription?.interval === "once") {
    return null;
  }

  const daysLeft = Math.round(
    (periodEndDate.getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24),
  );

  if (daysLeft > 10) {
    return null;
  }

  return (
    <div className="p-2 flex items-center justify-center border-b">
      {daysLeft <= 0 && <SubscriptionDue />}
    </div>
  );
}
